import { create } from "zustand";

function storeToggle(set) {
  return {
    active: true,
    panel: false,
    setActive: (val) => set((state) => ({ ...state, active: val })),
    setSlidePanel: (val) => set((state) => ({ ...state, panel: val })),
  };
}

const useToggle = create(storeToggle);

function storeDropzone(set) {
  return {
    files: [],
    error: [],
    oldFiles: [],
    clearState: () =>
      set({
        file: [],
        error: [],
        oldFiles: [],
      }),
  };
}

const useStoreDropzone = create(storeDropzone);

export { useToggle, useStoreDropzone };
